<template>
  <Accordion>
    <AccordionTab>
      <template #header>
        <span class="flex items-center gap-2 w-full">
          <mdicon name="text-box-search-outline" class="text-indigo-400" size="20" />
          <span class="font-source font-medium">Sources - {{ (message?.sources || []).length }} documents</span>
        </span>
      </template>
      <div class="ml-1 pl-3 border-l-2 border-indigo-100">
        <dl class="grid grid-cols-1 sm:grid-cols-2">
          <div class="px-4 py-2 sm:col-span-2 sm:px-0">
            <dt class="text-sm text-gray-500">KB Query</dt>
            <dd class="mt-1 text-md text-slate-600 font-medium font-source sm:mt-2">
              {{ message?.ragNeeded ? message?.ragQuery : 'Not needed' }}
            </dd>
          </div>
          <div v-if="message?.ragQueryReason && message?.ragQueryReason !== ''" class="px-4 py-2 sm:col-span-2 sm:px-0">
            <dt class="text-xs text-gray-500">Query Reason</dt>
            <dd class="mt-1 text-sm text-slate-500 font-medium font-source sm:mt-2">
              {{ message?.ragQueryReason }}
            </dd>
          </div>
          <div class="border-t border-gray-100 px-4 pt-4 sm:col-span-2 sm:px-0">
            <dt class="text-sm font-medium text-gray-500">Documents used for this answer</dt>
            <dd class="mt-2 text-gray-900">
              <ul role="list" class="divide-y divide-gray-100 rounded-md">
                <li v-for="(item, idx) in message.sources" :key="idx" class="flex items-center justify-between py-3 pr-5">
                  <div class="flex w-0 flex-1 items-center">
                    <router-link :to="{ path: `/kb/editor/${kbId}/document/${kbStore.getHashID(item)}` }" target="_blank">
                      <div class="flex items-center">
                        <mdicon name="file-document-outline" size="20" class="text-gray-400 mr-1" aria-hidden="true"></mdicon>
                        <div class="cursor-pointer text-md hover:underline font-medium text-slate-600 hover:text-slate-800">{{ item }}</div>
                        <mdicon name="open-in-new" size="18" class="ml-1 text-slate-300"></mdicon>
                      </div>
                    </router-link>
                  </div>
                  <div v-if="item.startsWith('http')" class="ml-4 flex-shrink-0 flex items-center">
                    <a :href="item" target="_blank" class="cursor-pointer text-md hover:underline font-medium text-slate-600 hover:text-slate-800">Visit</a>
                    <mdicon name="open-in-new" size="18" class="ml-1 text-slate-300"></mdicon>
                  </div>
                </li>
              </ul>
            </dd>
          </div>
        </dl>
      </div>
      <!--
      <ul class="m-0">
        <li v-if="message?.ragNeeded" class="font-source text-xs mb-2 hover:text-violet-700">
          RAG Needed: <span class="font-medium">{{ message.ragNeeded }}</span>
        </li>
        <li v-if="message?.ragQuery" class="font-source text-xs mb-2 hover:text-violet-700">
          Query: <span class="font-medium">{{ message.ragQuery }}</span>
        </li>
        <li v-if="message?.ragQueryReason" class="font-source text-xs mb-2 hover:text-violet-700">
          Query Reason: <span class="font-medium">{{ message.ragQueryReason }}</span>
        </li>
        <li v-for="(item, idx) in message.sources" class="font-source text-xs mb-2 hover:text-violet-700">
          <a v-if="item.startsWith('http')" :href="item" target="_blank">{{ item }}</a>
          <span v-else>{{ item }}</span>
        </li>
      </ul>-->
    </AccordionTab>
  </Accordion>
</template>

<script setup>
  import { ref } from 'vue';
  import { useKbStore } from '@/store/KbStore';
  import Accordion from 'primevue/accordion';
  import AccordionTab from 'primevue/accordiontab';

  const props = defineProps({
    botId: {
      type: String,
      default: null,
    },
    kbId: {
      type: String,
      default: null,
    },
    message: {
      type: Object,
      default() {
        return {};
      },
    },
  });

  const kbStore = useKbStore();
</script>
